import { StopsPartialStoreState, STOPS_STATE_KEY } from './stops.reducer';

export const getAllById = (state: StopsPartialStoreState) => state[STOPS_STATE_KEY].byId;
export const getFiltered = (state: StopsPartialStoreState) => state[STOPS_STATE_KEY].filtered;

export const getAllAreas = (state: StopsPartialStoreState) => state[STOPS_STATE_KEY].allAreas;

export const getGroups = (state: StopsPartialStoreState) => state[STOPS_STATE_KEY].groups;
export const getSelectedGroup = (state: StopsPartialStoreState) => state[STOPS_STATE_KEY].selectedGroup;
export const getSelectedGroupMapFile = (state: StopsPartialStoreState) =>
    state[STOPS_STATE_KEY].selectedGroup
        ? `maps/${state[STOPS_STATE_KEY].selectedGroup?.extra_information?.fileName}`
        : state[STOPS_STATE_KEY].defaultGroup
        ? `maps/${state[STOPS_STATE_KEY].defaultGroup.extra_information.fileName}`
        : null;

export const getAllOrigins = (state: StopsPartialStoreState) => state[STOPS_STATE_KEY].origins;
export const getSelectedOrigin = (state: StopsPartialStoreState) => state[STOPS_STATE_KEY].selectedOrigin;
export const getSelectedDestination = (state: StopsPartialStoreState) => state[STOPS_STATE_KEY].selectedDestination;
